import { Paper, Stack, Typography } from '@mui/material';

interface ClinicalCardFrameProps {
  title: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Presentational stand-in for the shared V1 `BaseBlock` card chrome
 * (components/Patient/Blocks/BaseBlock): a bordered Paper with a bold title on
 * the left and an actions slot (filter + "+ Add") on the right. Domain-agnostic
 * on purpose — the Medications, Diagnoses, and Allergies card mocks all render
 * inside this one frame, mirroring how the real build passes controls to
 * BaseBlock's `actions` prop.
 */
export const ClinicalCardFrame: React.FC<ClinicalCardFrameProps> = ({
  title,
  actions,
  children,
}) => (
  <Paper
    elevation={1}
    sx={{
      maxWidth: 1040,
      mx: 'auto',
      // BaseBlock's inter-module rhythm on the V1 patient page.
      mb: 2,
      borderRadius: '0.75rem',
      border: '1px solid',
      borderColor: 'divider',
      overflow: 'hidden',
    }}
  >
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        px: 2,
        py: 1.5,
        flexWrap: 'wrap',
      }}
    >
      <Typography variant="h6" noWrap sx={{ fontWeight: 700 }}>
        {title}
      </Typography>
      {actions && (
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          {actions}
        </Stack>
      )}
    </Stack>
    {children}
  </Paper>
);
